import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import Axios from 'axios';
import * as Yup from 'yup';
import ErrorMessages from '../../errorConfig';
import PmsUrlConfig from '../../urlConfig';
import { emailRegex } from '../common';
import { Link, useLocation } from 'react-router-dom';


const ForgotPasswordSchema = Yup.object().shape({

    userEmail: Yup.string()
        .required(ErrorMessages.EMAIL_REQUIRED)
        .matches(emailRegex, ErrorMessages.EMAIL_INVALID),

});

export default function ForgotPasswordForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const [serverErr, setServerError] = useState('');

    const clearInputFields = () => {
        document.getElementById("forgot-password-form").reset();
    }

    return (
        <div className="forgot-password-form">

            <Formik
                initialValues={{
                    userEmail: '',
                }}
                validationSchema={ForgotPasswordSchema}
                onSubmit={(values, { setSubmitting }) => {

                    var generateCodeUrl = PmsUrlConfig.BOS_GENERATE_CODE_URL + "/" + values.userEmail;
                    Axios.get(generateCodeUrl).then((response) => {
                        if (response.status === 200) {
                            var patientUser = response.data.email_id;
                            navigate(`${PmsUrlConfig.VERIFY_CODE_URL}`, { state: { email: patientUser, message: `${response.data.success_message}` } });
                        }
                        else if (response.status === 400) {
                            setSubmitting(false);
                            setServerError(response.data.error_code.description);
                            console.log(response.data.error_code.description);

                        }
                    }).catch((error) => {
                        setSubmitting(false);
                        console.log("-----------------", error)
                        setServerError(error.response.data.error_code.description);
                        console.log(error.response.data.error_code.description);

                    })
                }}
                onReset={(values) => {
                    clearInputFields();

                }}
            >
                {({ errors, touched, values, handleChange, isSubmitting, handleReset, handleBlur, setFieldValue }) => (
                    <Form data-testid='forgot-password-form' id="forgot-password-form">
                        <div className="w-full flex justify-center">
                            <div
                                className="
      w-full
      max-w-md
      md:max-w-lg
      lg:max-w-xl
      xl:max-w-2xl
    "
                            >
                                {/* Server error */}
                                {serverErr && (
                                    <div className="mb-4 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-red-700">
                                        Error: {serverErr}
                                    </div>
                                )}

                                {/* Location error */}
                                {location.state?.message && (
                                    <div className="mb-4 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-red-700">
                                        {location.state.message}
                                    </div>
                                )}

                                {/* Card */}
                                <div className="rounded-lg border border-gray-200 bg-white shadow-md">
                                    {/* Header */}
                                    <div className="border-b px-6 py-4">
                                        <h3 className="text-xl font-semibold text-gray-800">
                                            Forgot Password
                                        </h3>
                                    </div>

                                    {/* Body */}
                                    <div className="px-6 py-6">
                                        <div className="w-full md:w-1/2">
                                            <label
                                                htmlFor="userEmail"
                                                className="mb-1 block text-sm font-medium text-gray-700"
                                            >
                                                Email <span className="text-red-500">*</span>
                                            </label>

                                            <Field
                                                type="email"
                                                id="userEmail"
                                                name="userEmail"
                                                className={`
              w-full rounded-md border px-3 py-2 text-sm
              focus:outline-none focus:ring-2 focus:ring-teal-500
              ${errors.userEmail && touched.userEmail
                                                        ? 'border-red-500'
                                                        : 'border-gray-300'
                                                    }
            `}
                                            />

                                            {errors.userEmail && touched.userEmail && (
                                                <p className="mt-1 text-sm text-red-600">
                                                    {errors.userEmail}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Button */}
                                <div className="mt-6 flex justify-center">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="
          rounded-md
          bg-[rgba(11,109,118,1)]
          px-6 py-2
          text-white
          text-sm font-medium
          hover:opacity-90
          disabled:opacity-50
        "
                                    >
                                        Generate Code
                                    </button>
                                </div>

                                {/* Login link */}
                                <div className="mt-4 text-center text-sm">
                                    <Link
                                        to={PmsUrlConfig.HOME_URL}
                                        className="text-teal-700 hover:underline"
                                    >
                                        Login
                                    </Link>
                                </div>
                            </div>
                        </div>

                    </Form>
                )}
            </Formik>
        </div>
    );
}